import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiPhone, FiMapPin, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-700 to-purple-900 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl font-figtree">RS</span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-white font-figtree">RSA Solutions</h1>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Gauteng's premier management consulting partnership, delivering transformative solutions that drive sustainable growth across diverse industries for over two decades.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-yellow-400" />
                <span className="text-gray-300">Sandton, Johannesburg, Gauteng</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-yellow-400" />
                <span className="text-gray-300">+27 11 555 0123</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-yellow-400" />
                <span className="text-gray-300">info@rsasolutions.co.za</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services/strategic-planning" className="text-gray-300 hover:text-yellow-400 transition-colors">Strategic Planning</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-yellow-400 transition-colors">Operational Excellence</Link></li>
              <li><Link to="/services/digital-transformation" className="text-gray-300 hover:text-yellow-400 transition-colors">Digital Transformation</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-yellow-400 transition-colors">Risk Management</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-yellow-400 transition-colors">M&A Advisory</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">About Us</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-yellow-400 transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">Contact</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">Careers</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 RSA Solutions. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              Website by <a href="https://www.primehost.co.za/" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 transition-colors">Primehost</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;